var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar',{attrs:{"position":"fixed","transparent":_vm.transparent,"color-on-scroll":_vm.colorOnScroll,"menu-classes":"ml-auto"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var toggle = ref.toggle;
var isToggled = ref.isToggled;
return [_c('router-link',{directives:[{name:"popover",rawName:"v-popover:popover1",arg:"popover1"}],staticClass:"navbar-brand",attrs:{"to":"/"}},[_vm._v("Obsidian Solutions")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }